<template>
  <div>
    <div class="outmain ba_f">
      <div class="pagetitle mar_b20">{{ $t('data.rider.title') }}</div>
      <div class="main-icon flex t_l mar_t20">
        <div class="flex-1 t_l pad_20 ba_f8 mar_r20">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.rider.pendingReviewCount') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{info.waitRider}}</p>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 ba_f8 mar_r20">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.rider.acceptedRiderCount') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{info.receivingNum}}</p>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 ba_f8 mar_r20">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.rider.totalRiderCount') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{info.totalRider}}</p>
            </div>
          </div>
        </div>
        <div class="flex-1 t_l pad_20 ba_f8 mar_r20">
          <div class="flex-bet flex-y-top">
            <div>
              <p class="title6 fon_14">{{ $t('data.rider.totalRegisterCount') }}</p>
              <p class="fon_30 title35 lh16 pad_tb_20">{{info.totalRegisterRider}}</p>
            </div>
          </div>
        </div>
      </div>
      <div id="zhentiEch" style="height: 360px;" class="mar_t40"></div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts';
import { riderAnalysis } from '@/api/data';
export default {
  mounted() {
    this.getInfo();
  },
  data() {
    return {
      tableData: [],
      info: {},
      echarts2_option: {
        color: ['#476FEC', '#42CCF0'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
            lineStyle: {
              color: '#ccc',
              type: 'dashed'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#4ECB73',
              width: 2
            }
          },
          data: []
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#333',
              fontSize: '12'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#DDDDDD'
            },
            show: true
          }
        },
        series: [
          {
            name: '',
            type: 'line',
            stack: '',
            smooth: true,
            data: []
          },
          {
            name: '',
            type: 'line',
            stack: '',
            smooth: true,
            data: []
          }
        ]
      }
    };
  },
  methods: {
    applyChartI18n() {
      this.echarts2_option.legend.data = [
        this.$t('data.rider.chartNewRider'),
        this.$t('data.rider.chartNewRegister'),
      ];
      this.echarts2_option.series[0].name = this.$t('data.rider.chartNewRider');
      this.echarts2_option.series[0].stack = this.$t('data.rider.chartStackTotal');
      this.echarts2_option.series[1].name = this.$t('data.rider.chartNewRegister');
      this.echarts2_option.series[1].stack = this.$t('data.rider.chartStackTotal');
    },
    getInfo() {
      riderAnalysis().then((res) => {
        if (res.code == 1) {
          this.info = res.data;
          this.applyChartI18n();
          this.echarts2_option.series[0].data = this.info.chart.map((item) => item.money);
          this.echarts2_option.series[1].data = this.info.chart.map((item) => item.attestationNum);
          this.echarts2_option.xAxis.data = this.info.chart.map((item) => item.hours);
          this.zhentiEch();
        }
      });
    },
    zhentiEch() {
      let myChart = echarts.init(document.getElementById('zhentiEch'));
      myChart.setOption(this.echarts2_option, true);
    }
  }
};
</script>
